import { css } from "emotion";
import H3 from "../../components/global/H3";
import ColorServices from "../../services/ColorServices";
import { max, lastOfType } from "../../utils/CssUtils";
import P from "../../components/global/P";

const bp = [1140, 844, 600];

const wrapper = css({
  paddingTop: 0,
  margin: "72px auto 72px calc((100vw - 1200px) / 2)",
  paddingLeft: 518,
  display: "flex",
  flexDirection: "row-reverse",
  [max(bp[0])]: {
    paddingLeft: 535
  },
  [max(bp[1])]: {
    paddingLeft: 1,
    paddingTop: "calc(340px - 68px)",
    margin: "40px auto 72px auto"
  },
  [max(bp[2])]: {
    paddingTop: "calc(194px - 40px + 0.55 * (100vw - 320px))", // calculates the scaling of the image
    margin: "40px auto 40px auto"
  }
});

const textBlockWrapper = css({
  position: "relative",
  backgroundColor: ColorServices.getColor("turquoise"),
  width: "100%",
  borderTopLeftRadius: 4,
  borderBottomLeftRadius: 4,
  minHeight: 404,
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  padding: "40px 0 40px 122px",
  [max(bp[0])]: {
    padding: "20px 0 20px 122px",
    minHeight: 277
  },
  [max(bp[1])]: {
    padding: "104px 14px 40px 14px",
    maxWidth: 682,
    margin: "auto",
    minHeight: 0
  },
  [max(bp[2])]: {
    padding: "calc(64px + 0.1 * (100vw - 320px)) 14px 40px 14px",
    minHeight: 0
  }
});

const textBlock = css({
  marginRight: "auto",
  maxWidth: 480,
  [max(bp[0])]: {
    maxWidth: "none",
    paddingRight: 40
  },
  [max(bp[1])]: {
    marginRight: 0,
    maxWidth: "100%",
    paddingRight: 0
  },
  h3: {
    marginBottom: 16
  },
  p: {
    [lastOfType()]: {
      marginBottom: 0
    },
    marginBottom: 12
  }
});

const imageStyles = css({
  position: "absolute",
  maxWidth: 510,
  maxHeight: 340,
  width: "100%",
  top: "calc(50% - 340px / 2)",
  left: "calc(72px - 510px)",
  borderRadius: 4,
  boxShadow: "0 1px 10px 0 rgba(9, 30, 66, 0.13)",
  [max(bp[0])]: {
    top: `calc((100% - 233px) / 2)`,
    left: "calc(72px - 350px)",
    maxWidth: 350
  },
  [max(bp[1])]: {
    top: 0,
    transform: "translate(-50%, -80%)",
    left: "50%",
    maxWidth: 510
  },
  [max(bp[2])]: {
    maxWidth: "calc(100% - 28px)"
  }
});

const explanationWrapper = css({
  p: {
    [lastOfType()]: {
      marginBottom: 0
    },
    marginBottom: 12
  }
});

const DescriptionBlock = ({ image, heading, text, alt }) => {
  const paragraphs = Array.isArray(text) ? (
    text.map(paragraph => <P>{paragraph}</P>)
  ) : (
    <P>{text}</P>
  );

  return (
    <div className={wrapper}>
      <div className={textBlockWrapper}>
        <img className={imageStyles} src={image} alt={alt} />
        <div className={textBlock}>
          <H3>{heading}</H3>
          <div className={explanationWrapper}>{paragraphs}</div>
        </div>
      </div>
    </div>
  );
};

export default DescriptionBlock;
